import { render, staticRenderFns } from "./APIList.vue?vue&type=template&id=1305907f&scoped=true&"
import script from "./APIList.vue?vue&type=script&lang=js&"
export * from "./APIList.vue?vue&type=script&lang=js&"
import style0 from "./APIList.vue?vue&type=style&index=0&id=1305907f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305907f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VFlex,
  VLayout,
  VSwitch,
})
